import React, { useEffect, useRef, useState } from "react";
import MainContent from "components/MainContent";
import LoginForm from "forms/LoginForm/LoginForm";
import { logout } from "api/functions/functions";
import useUser from "hooks/useUser";

const Login = () => {

    const formWrapper = useRef()
    const image = useRef()

    const [offsetWidth, setOffsetWidth] = useState()

    const {
        getUserName
    } = useUser()

    const logCurrentUserOut = () => {
        logout()
    }

    useEffect(() => {
        const newOffsetWidth = (formWrapper.current) ? formWrapper.current.offsetWidth : 0
        setOffsetWidth(newOffsetWidth)
    })

    useEffect(() => {
        if (getUserName()) {
            logCurrentUserOut()
        }
    }, [getUserName])

    return (
        <MainContent narrow={false}>
            <div
                ref={formWrapper}
                className="login-form-container"
                style={{
                    position: "fixed",
                    left: 0,
                    top: "3rem",
                    paddingTop: "3rem",
                    height: "calc(100vh - 3rem)",
                    backgroundColor: "#000000"
                }}
            >
                <LoginForm />
            </div>
            <div
                style={{
                    position: "fixed",
                    left: `${offsetWidth}px`,
                    top: "3rem",
                    paddingTop: "3rem",
                    height: "calc(100vh - 3rem)",
                    backgroundColor: "#e22",
                    width: `calc(100% - ${offsetWidth}px)`,
                    backgroundImage: "url(/img/woodpecker-1.jpg)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "left top"
                }}
                ref={image}
            />
        </MainContent>
    );
};

export default Login;
